var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "grid" } },
    [
      _c(
        "button",
        {
          staticClass: "btn btn-empty btn-open",
          attrs: { id: "view-detail-btn-" + _vm.transaction.IdTransaction },
          on: {
            click: function ($event) {
              return _vm.openModal()
            },
          },
        },
        [_c("i", { staticClass: "fa-light fa-eye" })]
      ),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          attrs: {
            target: "view-detail-btn-" + _vm.transaction.IdTransaction,
            triggers: "hover",
            placement: "top",
            "custom-class": "popover-btn",
          },
        },
        [_vm._v("\n    View detail\n  ")]
      ),
      _vm._v(" "),
      _vm.isModalOpen
        ? _c("div", { staticClass: "modal-container" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("h1", [
                _vm._v("Reconciliation Details"),
                _c("i", {
                  staticClass: "fa-regular fa-xmark",
                  on: {
                    click: function ($event) {
                      return _vm.closeModal()
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "span",
                { staticStyle: { "font-weight": "normal", color: "#717182" } },
                [
                  _vm._v(
                    "Complete information for reconciliation " +
                      _vm._s("REC-" + _vm.transaction.Lettrage.padStart(6, "0"))
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "card info-container p-6" }, [
                _c("div", [
                  _c(
                    "span",
                    {
                      staticStyle: { "font-size": "0.9rem", color: "#4a5565" },
                    },
                    [_vm._v("Reference")]
                  ),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s("REC-" + _vm.transaction.Lettrage.padStart(6, "0"))
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "span",
                    {
                      staticStyle: { "font-size": "0.9rem", color: "#4a5565" },
                    },
                    [_vm._v("Matched By")]
                  ),
                  _vm._v(" "),
                  _vm.transaction.ReconciliationMode == 1
                    ? _c("span", { staticClass: "btn btn-dark" }, [
                        _vm._v("Automatic"),
                      ])
                    : _c("span", { staticClass: "btn btn-dark" }, [
                        _vm._v("Manual"),
                      ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "span",
                    {
                      staticStyle: { "font-size": "0.9rem", color: "#4a5565" },
                    },
                    [_vm._v("Created")]
                  ),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        new Date(_vm.transaction.CreationDate).toLocaleString()
                      )
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "card p-6",
                  staticStyle: { display: "grid", gap: "2rem 0rem" },
                },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticStyle: { display: "grid" } }, [
                    _c("span", { staticStyle: { "font-size": "0.85rem" } }, [
                      _vm._v("Rule Name"),
                    ]),
                    _vm._v(" "),
                    _vm.transaction.ReconciliationMode == 1
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "1.25rem",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v("Auto Reconciliation")]
                        )
                      : _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "1.25rem",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v("Manual Reconciliation (No Rule)")]
                        ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                    gap: "1rem",
                  },
                },
                [
                  _c("div", { staticClass: "card stats" }, [
                    _c("span", [_vm._v("Total Orders")]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#155dfc",
                          "font-weight": "bold",
                          "font-size": "1.5rem",
                        },
                      },
                      [_vm._v("€" + _vm._s(Number(_vm.totalOrder).toFixed(2)))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card stats" }, [
                    _c("span", [_vm._v("Total Payments")]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#00a63e",
                          "font-weight": "bold",
                          "font-size": "1.5rem",
                        },
                      },
                      [
                        _vm._v(
                          "€" + _vm._s(Number(_vm.totalPayments).toFixed(2))
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card stats" }, [
                    _c("span", [_vm._v("Delta")]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        style: {
                          color:
                            Number(_vm.totalOrder) -
                              Number(_vm.totalPayments) ==
                            0
                              ? "#4a5565"
                              : "#f54a00",
                          "font-size": "1.5rem",
                          "font-weight": "bold",
                        },
                      },
                      [
                        _vm._v(
                          "+€" +
                            _vm._s(
                              Number(_vm.delta).toFixed(2).replace("-", "")
                            )
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card p-6" },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-weight": "bold",
                        "font-size": "1.25rem",
                      },
                    },
                    [
                      _vm._v(
                        "All Transactions in this Reconciliation (" +
                          _vm._s(_vm.transactions.length) +
                          ")"
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("b-table", {
                    staticClass: "table-header-border",
                    staticStyle: { "margin-bottom": "0", "margin-top": "2rem" },
                    attrs: {
                      responsive: "",
                      items: _vm.transactions,
                      fields: _vm.fields,
                      "primary-key": "id",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "cell(date)",
                          fn: function (data) {
                            return [
                              _c("div", { staticStyle: { display: "grid" } }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      new Date(
                                        data.item.CreationDate
                                      ).toLocaleDateString()
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#6a7282",
                                      "font-size": "0.85rem",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        new Date(
                                          data.item.CreationDate
                                        ).toLocaleTimeString()
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "cell(type)",
                          fn: function (data) {
                            return [
                              data.item.Type == 1 && data.item.Direction == 0
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "btn btn-empty",
                                      staticStyle: {
                                        display: "flex",
                                        gap: "0.5rem",
                                        "align-items": "center",
                                        "justify-content": "center",
                                        cursor: "default",
                                        color: "#008236",
                                        "background-color": "#f0fdf4",
                                        "border-color": "#b9f8cf",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-light fa-credit-card",
                                      }),
                                      _vm._v(
                                        "\n              Payment\n            "
                                      ),
                                    ]
                                  )
                                : data.item.Type == 0 &&
                                  data.item.Direction == 1
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "btn btn-empty",
                                      staticStyle: {
                                        display: "flex",
                                        gap: "0.5rem",
                                        "align-items": "center",
                                        "justify-content": "center",
                                        cursor: "default",
                                        color: "#1d4ed8",
                                        "background-color": "#eff6ff",
                                        "border-color": "#bfdbfe",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-light fa-money-bill",
                                      }),
                                      _vm._v(
                                        "\n              Order\n            "
                                      ),
                                    ]
                                  )
                                : data.item.Type == 11 || data.item.Type == 3
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "btn btn-empty",
                                      staticStyle: {
                                        display: "flex",
                                        gap: "0.5rem",
                                        "align-items": "center",
                                        "justify-content": "center",
                                        cursor: "default",
                                        color: "#a16207",
                                        "background-color": "#fefce8",
                                        "border-color": "#fef08a",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa-light fa-money-bill-transfer",
                                      }),
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            data.item.Type == 11
                                              ? "Refund"
                                              : data.item.Type == 3
                                              ? "Credit Note"
                                              : ""
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _c("span", [_vm._v("—")]),
                            ]
                          },
                        },
                        {
                          key: "cell(viban)",
                          fn: function (data) {
                            return [
                              _c("span", [_vm._v(_vm._s(data.item.VIBAN))]),
                            ]
                          },
                        },
                        {
                          key: "cell(client)",
                          fn: function (data) {
                            return [
                              data.item.PaymentGroupIdentifier2
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(data.item.PaymentGroupIdentifier2)
                                    ),
                                  ])
                                : _c("span", [_vm._v("—")]),
                            ]
                          },
                        },
                        {
                          key: "cell(reference)",
                          fn: function (data) {
                            return [
                              data.item.InvoiceIdentifier
                                ? _c("span", [
                                    _vm._v(_vm._s(data.item.InvoiceIdentifier)),
                                  ])
                                : _c("span", [_vm._v("—")]),
                            ]
                          },
                        },
                        {
                          key: "cell(amount)",
                          fn: function (data) {
                            return [
                              _c(
                                "span",
                                {
                                  style: {
                                    color:
                                      data.item.InvoiceType == "Standard" &&
                                      data.item.Direction == 0
                                        ? "#00a63e"
                                        : data.item.InvoiceType == "Standard" &&
                                          data.item.Direction == 1
                                        ? "red"
                                        : data.item.Amount >= 0
                                        ? "#00a63e"
                                        : "red",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        data.item.InvoiceType == "Standard" &&
                                          data.item.Direction == 0
                                          ? "+"
                                          : data.item.InvoiceType ===
                                              "Standard" &&
                                            data.item.Direction == 1
                                          ? "-"
                                          : "+"
                                      ) +
                                      "€" +
                                      _vm._s(
                                        Number(data.item.Amount).toFixed(2)
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: "cell(description)",
                          fn: function (data) {
                            return [
                              data.item.description
                                ? _c("span", [
                                    _vm._v(_vm._s(data.item.description)),
                                  ])
                                : _c("span", [_vm._v("—")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1181827884
                    ),
                  }),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticStyle: { "font-size": "0.9rem", color: "#4a5565" } }, [
        _vm._v("Status"),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "btn-active" }, [
        _c("i", { staticClass: "fa-light fa-circle-check" }),
        _vm._v(" Active"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticStyle: {
          "font-size": "1.25rem",
          "font-weight": "bold",
          display: "flex",
          gap: "0.75rem",
          "align-items": "center",
        },
      },
      [
        _c("i", {
          staticClass: "fa-light fa-info-circle",
          staticStyle: { color: "#155dfc", "font-size": "1.5rem" },
        }),
        _vm._v("Reconciliation Rule Used "),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }